export const NUMBER = 421;
export const NAME = `Root card must be a quest header`;
export const METADATA_ERROR = true;
export const DESCRIPTION = ``;

export const INVALID = [
`_roleplay_`,
];

export const VALID = [
`# Test Quest

_roleplay_`,
];
